import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowCornerDownRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-corner-down-right"} maskId="square-filled-radius-0-stroke-1-IconArrowCornerDownRight"><path fillRule="evenodd" clipRule="evenodd" d="M4 4V14.5H19.2929L15.2929 10.5L16 9.79289L21.2071 15L16 20.2071L15.2929 19.5L19.2929 15.5H3V4H4Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowCornerDownRight;
